/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import type { PreseedContentRequest } from '../schemas/PreseedContentRequest';
import { fetcher, FetcherOptions } from './fetcher';

export type DmsOrganizationPreSeedDataStandaloneCreateRequestBody =
  PreseedContentRequest;

export type DmsOrganizationPreSeedDataStandaloneCreateOkResponse = unknown;

export type DmsOrganizationPreSeedDataStandaloneCreateErrorResponse = unknown;

export interface DmsOrganizationPreSeedDataStandaloneCreateProps
  extends Omit<
    FetcherOptions<
      unknown,
      DmsOrganizationPreSeedDataStandaloneCreateRequestBody
    >,
    'url'
  > {
  body: DmsOrganizationPreSeedDataStandaloneCreateRequestBody;
}

export function dmsOrganizationPreSeedDataStandaloneCreate(
  props: DmsOrganizationPreSeedDataStandaloneCreateProps
): Promise<DmsOrganizationPreSeedDataStandaloneCreateOkResponse> {
  return fetcher<
    DmsOrganizationPreSeedDataStandaloneCreateOkResponse,
    unknown,
    DmsOrganizationPreSeedDataStandaloneCreateRequestBody
  >({
    url: `/dms/organization/pre_seed_data_standalone/`,
    method: 'POST',
    ...props
  });
}
